import { render } from "./CustomAreaManagerDraw.vue?vue&type=template&id=dd6bea82&scoped=true"
import script from "./CustomAreaManagerDraw.vue?vue&type=script&lang=js"
export * from "./CustomAreaManagerDraw.vue?vue&type=script&lang=js"

import "./CustomAreaManagerDraw.vue?vue&type=style&index=0&id=dd6bea82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd6bea82"]])

export default __exports__